import { hapticFeedback } from '@tma.js/sdk-react'

// Тактильный отклик. Вне Telegram или в старых клиентах — тихо ничего не делаем.

type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
type NotifyType = 'success' | 'error' | 'warning'

export const haptic = {
  selection(): void {
    try {
      hapticFeedback.selectionChanged.ifAvailable()
    } catch {
      // нет поддержки
    }
  },
  impact(style: ImpactStyle = 'light'): void {
    try {
      hapticFeedback.impactOccurred.ifAvailable(style)
    } catch {
      // нет поддержки
    }
  },
  notify(type: NotifyType): void {
    try {
      hapticFeedback.notificationOccurred.ifAvailable(type)
    } catch {
      // нет поддержки
    }
  },
}
